var iState = {
  percentage: 0,
  delta: 0,
  inertia: 3,
  inertiaSlower: 1.0,
  lv: 0,
  runWebGL: true
}

export const setPercentage = (v) => {
  iState.percentage = v
}

export const state = {
  set play (v) {
    iState.runWebGL = v
  },
  get play () {
    return iState.runWebGL
  },
  get delta () {
    return (iState.lv - iState.percentage) * iState.inertiaSlower
  },
  get percentage () {
    return iState.percentage
  },
  set percentage (v) {
    iState.lv = v
    iState.inertia = Math.abs(iState.lv - iState.percentage) / 0.91
    iState.inertiaSlower = 1.0
  }
}

let rAFID
let rAF = function () {
  rAFID = window.requestAnimationFrame(rAF)
  let diff = iState.lv - iState.percentage
  if (Math.abs((diff)) > 0) {
    iState.delta = diff
    iState.percentage += diff * iState.inertia
  }
  iState.inertia *= 0.91
  iState.inertiaSlower *= 0.9
}
rAF.id = rAFID

rAFID = window.requestAnimationFrame(rAF)



// WEBPACK FOOTER //
// ./src/components/Parts/ScrollMonitor/ScrollMonitor.js